exports = module.exports = require("../../../web-builder/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n", ""]);

// exports
exports.locals = {
	"active": "#00baff",
	"info": "#8b9fb7",
	"success": "#00d494",
	"warning": "#ffd757",
	"danger": "#ff6562"
};